import React from "react";

export default class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    if (process.env.NODE_ENV !== "production") {
      console.error("[RouteErrorBoundary]", error, info);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.locationKey !== this.props.locationKey && this.state.error) {
      this.setState({ error: null, info: null });
    }
  }

  reset = () => {
    this.setState({ error: null, info: null });
  };

  render() {
    if (!this.state.error) return this.props.children;

    const { error } = this.state;
    const status = error?.status || error?.response?.status;
    const message =
      error?.message ||
      error?.response?.data?.message ||
      "Something went wrong while loading this page.";

    const isServer = status >= 500 && status < 600;
    const isAuth = status === 401 || status === 403;

    return (
      <div className="page-enter">
        <div className="bg-white border border-slate-200 rounded-xl p-8 text-center max-w-xl mx-auto mt-8">
          <div className="w-12 h-12 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center text-2xl mx-auto mb-3">
            {isServer ? "⚠" : isAuth ? "🔒" : "✖"}
          </div>
          <h2 className="text-lg font-semibold text-vf-base mb-2">
            {isServer
              ? "The server hit a snag"
              : isAuth
              ? "You don't have access to this page"
              : "This page couldn't load"}
          </h2>
          <p className="text-sm text-vf-muted mb-4">
            {isServer
              ? "We're getting a 500 from the backend. Try again in a moment, or pick a different page."
              : message}
          </p>
          {process.env.NODE_ENV !== "production" && (
            <details className="text-left text-[11px] text-vf-muted bg-slate-50 border border-slate-200 rounded px-3 py-2 mb-4">
              <summary className="cursor-pointer text-vf-base font-medium">
                Technical details
              </summary>
              <pre className="whitespace-pre-wrap break-words mt-2">
                {String(error?.stack || message)}
              </pre>
            </details>
          )}
          <div className="flex gap-2 justify-center">
            <button
              onClick={this.reset}
              className="px-3 py-1.5 rounded border border-slate-300 text-xs"
            >
              Retry
            </button>
            <button
              onClick={() => {
                this.reset();
                window.location.assign("/admin/dashboard-v2");
              }}
              className="px-3 py-1.5 rounded bg-vf-primary text-white text-xs"
            >
              Back to dashboard
            </button>
          </div>
        </div>
      </div>
    );
  }
}
